import { render, staticRenderFns } from "./DealTradeChain.vue?vue&type=template&id=218ecc99&scoped=true"
import script from "./DealTradeChain.vue?vue&type=script&lang=js"
export * from "./DealTradeChain.vue?vue&type=script&lang=js"
import style0 from "./DealTradeChain.vue?vue&type=style&index=0&id=218ecc99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ecc99",
  null
  
)

export default component.exports